import ModalViewOriginalRow from './ModalViewOriginalRow-compose';

export default ModalViewOriginalRow;
